import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { TextIcon16Solid } from "../../../../../icons2022/FileTypeTextIcon/TextIcon16Solid";
import { TextIcon20Solid } from "../../../../../icons2022/FileTypeTextIcon/TextIcon20Solid";
import { TextIcon24Solid } from "../../../../../icons2022/FileTypeTextIcon/TextIcon24Solid";
export var TextIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(TextIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(TextIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(TextIcon24Solid, null);
  }
}, 'TextIcon');